import text from './resources/locale/en.json';

class AttributePhonePreview {
    $onInit() {
        this.text = text;
    }
}

export default AttributePhonePreview;
